import { makeGet, makePost, makeDelete, makePut } from './ServiceManager';

export const getCarousels = async () => {
  const result = await makeGet('service/carousel/carousels');
  return result;
};

export const insertCarousel = async (carousel) => {
  const result = await makePost('service/carousel/carousel', { carousel });
  return result;
};

export const insertCarouselCard = async (card) => {
  const result = await makePost('service/carousel/carouselCard', { card });
  return result;
};

export const removeCarousel = async (id) => {
  const result = await makeDelete('service/carousel/carousel', { id });
  return result;
};

export const updateCarousel = async (carousel) => {
  const result = await makePut('service/carousel/carousel', { carousel });
  return result;
};

export const updateCarouselCard = async (card) => {
  const result = await makePut('service/carousel/carouselCard', { card });
  return result;
};

export const removeCarouselCards = async (id) => {
  const result = await makeDelete('service/carousel/carouselCard', { id });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/CarouselService.js